import { Formik, Form, Field, ErrorMessage } from "formik";
import React from "react";
import { css } from "@emotion/react";
import swal from "sweetalert";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export default () => (
  <Formik
    initialValues={{
      name: "",
      lastname: "",
      bedrijf: "",
      email: "",
      tel: "",
      message: "",
    }}
    onSubmit={(values, actions) => {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...values }),
      })
        .then(() => {
          swal(
            "Uw vraag is succesvol verzonden",
            "We nemen zo snel mogelijk contact met u op",
            "success"
          );
          actions.resetForm();
        })
        .catch(() => {
          swal(
            "Er heeft zich een fout voorgedaan",
            "Probeer het later opnieuw",
            "error"
          );
        })
        .finally(() => actions.setSubmitting(false));
    }}
    validate={(values) => {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      const errors = {};
      if (!values.name) {
        errors.name = "Dit veld is verplicht";
      }
      if (!values.lastname) {
        errors.lastname = "Dit veld is verplicht";
      }
      if (!values.email || !emailRegex.test(values.email)) {
        errors.email = "Ongeldig E-mail adres";
      }
      if (!values.tel) {
        errors.tel = "Dit veld is verplicht";
      }
      if (!values.message) {
        errors.message = "Dit veld is verplicht";
      }
      if (!values.checkbox) {
        errors.checkbox = "Dit veld moet aangevinkt zijn";
      }
      return errors;
    }}
  >
    {() => {
      const { t } = useTranslation();
      return (
        <div
          css={css`
            max-width: 700px;
          `}
        >
          <Form
            name="contact"
            data-netlify={true}
            css={css`
              display: flex;
              flex-direction: column;
            `}
          >
            <div
              css={css`
                width: 100%;
                display: flex;
                flex-direction: row;
                wrap: wrap;
              `}
            >
              <div
                css={css`
                  width: 50%;
                `}
              >
                <ErrorMessage
                  name="name"
                  render={(msg) => (
                    <div
                      css={css`
                        display: block;
                        font-size: 0.8em;
                        position: relative;
                        color: red;
                      `}
                    >
                      {msg}
                    </div>
                  )}
                />
              </div>
              <div
                css={css`
                  width: 50%;
                `}
              >
                <ErrorMessage
                  name="lastname"
                  render={(msg) => (
                    <div
                      css={css`
                        display: block;
                        font-size: 0.8em;
                        position: relative;
                        color: red;
                      `}
                    >
                      {msg}
                    </div>
                  )}
                />
              </div>
            </div>
            <div
              css={css`
                width: 100%;
                display: flex;
                flex-direction: row;
                wrap: wrap;
              `}
            >
              <div
                css={css`
                  width: 50%;
                `}
              >
                <Field
                  name="name"
                  placeholder={t("Voornaam*")}
                  css={css`
                    width: 90%;
                  `}
                />
              </div>
              <div
                css={css`
                  width: 50%;
                `}
              >
                <Field
                  name="lastname"
                  placeholder={t("Achternaam*")}
                  css={css`
                    width: 100%;
                  `}
                />
              </div>
            </div>
            <Field
              name="bedrijf"
              placeholder={t("Bedrijf")}
              css={css`
                width: 100%;
              `}
            />
            <div
              css={css`
                width: 100%;
              `}
            >
              <ErrorMessage
                name="email"
                render={(msg) => (
                  <div
                    css={css`
                      display: block;
                      font-size: 0.8em;
                      position: relative;
                      color: red;
                    `}
                  >
                    {msg}
                  </div>
                )}
              />
              <Field
                name="email"
                placeholder="Email*"
                css={css`
                  width: 100%;
                `}
              />
            </div>
            <div
              css={css`
                width: 100%;
              `}
            >
              <ErrorMessage
                name="tel"
                render={(msg) => (
                  <div
                    css={css`
                      display: block;
                      font-size: 0.8em;
                      position: relative;
                      color: red;
                    `}
                  >
                    {msg}
                  </div>
                )}
              />
              <Field
                name="tel"
                placeholder="Telefoonnummer*"
                css={css`
                  width: 100%;
                `}
              />
            </div>
            <div
              css={css`
                width: 100%;
              `}
            >
              <ErrorMessage
                name="message"
                render={(msg) => (
                  <div
                    css={css`
                      display: block;
                      font-size: 0.8em;
                      position: relative;
                      color: red;
                    `}
                  >
                    {msg}
                  </div>
                )}
              />
              <Field
                name="message"
                placeholder={t("Uw bericht*")}
                component="textarea"
                css={css`
                  width: 100%;
                `}
              />
            </div>
            <div>
              <ErrorMessage
                name="checkbox"
                render={(msg) => (
                  <div
                    css={css`
                      display: block;
                      font-size: 0.8em;
                      position: relative;
                      color: red;
                    `}
                  >
                    {msg}
                  </div>
                )}
              />
              <label>
                <Field
                  name="checkbox"
                  render={({ field, form }) => {
                    return (
                      <input type="checkbox" checked={field.value} {...field} />
                    );
                  }}
                />
                <Trans>
                  Ik geef toestemming aan Asbitech om contact met mij op te
                  nemen.*
                </Trans>
              </label>{" "}
            </div>

            <label>
              <Field
                name="nieuwsbrief"
                render={({ field, form }) => {
                  return (
                    <input type="checkbox" checked={field.value} {...field} />
                  );
                }}
              />{" "}
              <Trans>
                Ik wens mij te abonneren op de Asbitech nieuwsbrief en ontvang
                graag maandelijks handige tips & tricks in mijn mailbox.
              </Trans>
            </label>

            <button
              className="button submit"
              type="submit"
              css={css`
                margin-top: 2rem;
              `}
            >
              <Trans>Versturen</Trans>
            </button>
          </Form>
        </div>
      );
    }}
  </Formik>
);
